import { getTopmostPageDetail } from "utils";

/**
 *
 * @param {string} [urlOverride] for widgets wrapped in iFrames we need the
 * flexibility to override with a supplied referrerUrl
 * @returns {*}
 */
const getTopmostPageReferrer = (urlOverride) => urlOverride || getTopmostPageDetail().referrer;

export default getTopmostPageReferrer;
